import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { getMarathonAgreementsByMarathonId } from "api/thunk/offerAgreements/getActions/getMarathonAgreementById";
import { getAllMarathonAgreementsByMarathonId } from "api/thunk/offerAgreements/getActions/getAllMarathonAgreementsByMarathonId";
import { createMarathonAgreementsByMarathonId } from "api/thunk/offerAgreements/postActions/createMarathonAgreementsByMarathonId";
import { updateMarathonAgreementsByMarathonId } from "api/thunk/offerAgreements/putActions/updateMarathonAgreementsByMarathonId";

const offerAgreementsSlice = createSlice({
  name: "offerAgreements",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      //get_marathon_agreements_by_marathon-id
      .addCase(getMarathonAgreementsByMarathonId.pending, (state) => {
        state.marathonAgreementById.loading = true;
        state.marathonAgreementById.error = null;
      })
      .addCase(
        getMarathonAgreementsByMarathonId.fulfilled,
        (state, action) => {
          state.marathonAgreementById.loading = false;
          state.marathonAgreementById.data = action.payload;
        }
      )
      .addCase(getMarathonAgreementsByMarathonId.rejected, (state, action) => {
        state.marathonAgreementById.loading = false;
        state.marathonAgreementById.error = typeof action.payload === "string"
          ? action.payload
          : action.error.message || 'Неизвестная ошибка';
      })
      //get_marathon_agreements_by_marathon-id_all
      .addCase(getAllMarathonAgreementsByMarathonId.pending, (state) => {
        state.allMarathonAgreementById.response.loading = true;
        state.allMarathonAgreementById.response.error = null;
      })
      .addCase(
        getAllMarathonAgreementsByMarathonId.fulfilled,
        (state, action) => {
          state.allMarathonAgreementById.response.loading = false;
          state.allMarathonAgreementById.response.data = action.payload;
        }
      )
      .addCase(getAllMarathonAgreementsByMarathonId.rejected, (state, action) => {
        state.allMarathonAgreementById.response.loading = false;
        state.allMarathonAgreementById.response.error = typeof action.payload === "string"
          ? action.payload
          : action.error.message || 'Неизвестная ошибка';
      })
      //create_marathon_agreements_by_marathon-id
      .addCase(createMarathonAgreementsByMarathonId.pending, (state) => {
        state.createMarathonAgreementById.loading = true;
        state.createMarathonAgreementById.error = null;
      })
      .addCase(
        createMarathonAgreementsByMarathonId.fulfilled,
        (state, action) => {
          state.createMarathonAgreementById.loading = false;
          state.createMarathonAgreementById.data = action.payload;
        }
      )
      .addCase(createMarathonAgreementsByMarathonId.rejected, (state, action) => {
        state.createMarathonAgreementById.loading = false;
        state.createMarathonAgreementById.error = typeof action.payload === "string"
          ? action.payload
          : action.error.message || 'Неизвестная ошибка';
      })
      //update_marathon_agreements_by_marathon-id
      .addCase(updateMarathonAgreementsByMarathonId.pending, (state) => {
        state.updateMarathonAgreementById.loading = true;
        state.updateMarathonAgreementById.error = null;
      })
      .addCase(
        updateMarathonAgreementsByMarathonId.fulfilled,
        (state, action) => {
          state.updateMarathonAgreementById.loading = false;
          state.updateMarathonAgreementById.data = action.payload;
        }
      )
      .addCase(updateMarathonAgreementsByMarathonId.rejected, (state, action) => {
        state.updateMarathonAgreementById.loading = false;
        state.updateMarathonAgreementById.error = typeof action.payload === "string"
          ? action.payload
          : action.error.message || 'Неизвестная ошибка';
      })
  },
});

export default offerAgreementsSlice.reducer;



